import React from 'react';

export default React.createContext({ isScrolling: false });



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeaderII/context.js